import { ServerVm } from './server.vm';

export class GetServerVm extends ServerVm {}
